// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__0zObV","wrapper_image":"styles_wrapper_image__TC6fx","wrapper_skeletone":"styles_wrapper_skeletone__dwntz"};